<template>
  <div>
    <b-modal
      id="modal-sorting-device-add"
      ref="modal"
      v-model="open"
      hide-footer
      no-close-on-backdrop
      size="lg"
      :title="modalTitle"
    >
      <b-overlay
        id="overlay-background"
        :show="loading"
        blur="10px"
        opacity="0.30"
        rounded="sm"
        variant="light"
      >
        <ValidationObserver
          ref="createSortingDeviceForm"
          v-slot="{ handleSubmit }"
          slim
        >
          <b-form
            class="my-8"
            @submit.prevent="handleSubmit(handleFormSubmit)"
          >
            <b-row>
              <b-col
                cols="12"
              >
                <b-form-group
                  class="required"
                  label="Device Name"
                  label-cols-md="4"
                  label-for="h-dName"
                >
                  <ValidationProvider
                    #default="{ errors }"
                    name="name"
                    rules="required"
                  >
                    <b-form-input
                      id="name"
                      v-model="form.name"
                      placeholder="Enter Device Name"
                      type="text"
                      autocomplete="nope"
                      required
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </ValidationProvider>
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
              >
                <b-form-group
                  class="required"
                  label="Device IP"
                  label-cols-md="4"
                  label-for="h-dIP"
                >
                  <ValidationProvider
                    #default="{ errors }"
                    name="name"
                    rules="required"
                  >
                    <b-form-input
                      id="h-dIP"
                      v-model="form.device_ip"
                      placeholder="Enter Device IP"
                      type="text"
                      autocomplete="nope"
                      required
                      :disabled="modalPurpose === 'edit'"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </ValidationProvider>
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
              >
                <b-form-group
                  label="Bucket"
                  label-cols-md="4"
                  label-for="h-branch"
                >
                  <v-select
                    v-model="form.sorting_node_id"
                    :options="branchOptions"
                    :reduce="option => option.id"
                    label="name"
                    placeholder="Select Bucket"
                  >
                    <template v-slot:option="option">
                      {{ option.name }}
                    </template>
                  </v-select>
                </b-form-group>
              </b-col>
              <!-- submit and reset -->
              <b-col
                offset-md="4"
              >
                <div>
                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    class="mr-1 custom-button-color"
                    type="submit"
                  >
                    Submit
                  </b-button>
                  <b-button
                    v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                    variant="outline-secondary"
                    @click="clearOnClick"
                  >
                    Clear
                  </b-button>
                </div>
              </b-col>
            </b-row>

          </b-form>
        </ValidationObserver>
      </b-overlay>
    </b-modal>

  </div>
</template>

<script>
import {
  BButton,
  BModal,
  BCol,
  BFormGroup,
  BForm,
  BFormInput,
  BRow,
  BOverlay,
  VBModal,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import SuccessMessage from '@core/mixins/SuccessMessage'
import ErrorMessage from '@core/mixins/ErrorMessage'
import { RepositoryFactory } from '@/repository/RepositoryFactory'

const sortingRepository = RepositoryFactory.get('sorting')

function initialState() {
  return {
    open: false,
    id: null,
    modalPurpose: 'add',
    loading: false,
    fields: [],
    form: {},
    branchOptions: [],
  }
}

export default {
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  components: {
    BButton,
    BModal,
    BCol,
    BFormGroup,
    BForm,
    BFormInput,
    BRow,
    BOverlay,
  },
  mixins: [SuccessMessage, ErrorMessage],
  data() {
    return initialState()
  },
  computed: {
    modalTitle() {
      // eslint-disable-next-line no-nested-ternary
      return this.modalPurpose === 'add' ? 'ADD NEW SORTING DEVICE' : 'EDIT SORTING DEVICE'
    },
  },
  methods: {
    async openModal(id, purpose) {
      await Object.assign(this.$data, initialState())
      this.loading = true
      this.open = true
      this.modalPurpose = purpose
      this.id = id
      await this.readDataforUnassignedBranch()
      if (this.modalPurpose === 'edit') {
        await this.fetchSortingDeviceDetails(this.id)
      }
      this.loading = false
    },
    async readDataforUnassignedBranch() {
      try {
        const { data } = (await sortingRepository.getUnassignedSortingBranches()).data
        this.branchOptions = data
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    async fetchSortingDeviceDetails(id) {
      try {
        const { data } = (await sortingRepository.getSortingDeviceById(id)).data
        this.form = data
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    async handleFormSubmit() {
      try {
        this.loading = true
        const data = {
          name: this.form.name,
          device_ip: this.form.device_ip,
          sorting_node_id: this.form.sorting_node_id,
        }
        let res
        if (this.modalPurpose === 'add') {
          res = await sortingRepository.createSortingDevice(data)
        } else {
          res = await sortingRepository.updateSortingDevice(this.form.id, data)
        }
        if (res.status === 200 || res.status === 201) {
          this.clearOnClick()
          this.open = false
          this.$parent.onClickRefresh()
          this.showSuccessMessage(`Sorting Device ${this.modalPurpose === 'add' ? 'Added' : 'Updated'} Successfully`)
        } else {
          this.showErrorMessage(`Cannot ${this.modalPurpose === 'add' ? 'Add' : 'Update'} Sorting Device`)
        }
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.loading = false
    },
    clearOnClick() {
      this.form = {}
    },
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/required.scss';

</style>
